"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cubeDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var cubeDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCube: _factoriesAny.createCube
};
exports.cubeDependencies = cubeDependencies;